<template>
  <v-container>
    <v-card>
      <v-card-title>Στοιχεία Πελάτη</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-autocomplete
          v-model="customer"
          :items="customers"
          :hint="`${customer.Cid}`"
          item-text="Name"
          item-value="customer_id"
          single-line
          persistent-hint
          return-object
          required
          :search-input.sync="searchCustomer"
          :loading="isLoading"
          :rules="[(v) => !!v.Cid || 'Customer is required']"
          label="Πελάτης"
          @change="updateVehicleList"
          >
          </v-autocomplete>
          <v-text-field
            v-model="recipient"
            prepend-icon="mdi-account"
            label="Παραλήπτης"
            >
          </v-text-field>
          <v-combobox
            v-model="vehicle"
            prepend-icon="mdi-truck"
            :items="vehicles"
            required
            :rules="[(v) => !!v || 'Plate number is required']"
            label="Όχημα"
            >
          </v-combobox>
          <v-textarea
            v-model="notes"
            rows="1"
            :auto-grow=true
            prepend-icon="mdi-notebook"
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
        </v-form>
            <div>
              <v-btn
                color="primary"
                class="ml-2 white--text"
                @click="saveQuote">
                <v-icon dark>mdi-content-save</v-icon> ΑΠΟΘΗΚΕΥΣΗ
              </v-btn>
            </div>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-10" >
      <v-card-title>Λίστα ανταλλακτικών</v-card-title>
      <v-data-table
        :headers="headers"
        :items="lineItems"
        item-key="id"
        :search="search"
        class="elevation-1"
        :item-class="rowClass"
        height="600px"
        fixed-header>
        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-100">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
              <v-btn
                color="primary"
                class="ml-2 white--text"
                @click="addNew">
                <v-icon dark>mdi-plus</v-icon>Προσθηκη
              </v-btn>
            </div>
              <v-spacer></v-spacer>
        <div class="text-right py-10 ma-5">
          <p><b>Σύνολο:</b>&nbsp;  {{ tocurr(sumTotals(lineItems)) }}</p>
          <p><b>ΦΠΑ 24%:</b>&nbsp; {{ tocurr(sumTotals(lineItems) *0.24 ) }}</p>
          <p><b>Γενικό Σύνολο:</b>&nbsp; {{ tocurr(sumTotals(lineItems) * 1.24 ) }}</p>
        </div>
          </v-toolbar>
        </template>
        <template v-slot:item.index="{ item }">
          <span>{{lineItems.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.sku="{ item }">
          <v-text-field v-model="editedItem.sku" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.sku}}</span>
        </template>
        <template v-slot:item.description="{ item }">
          <v-text-field v-model="editedItem.description" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.description}}</span>
        </template>
        <template v-slot:item.qty="{ item }">
          <v-text-field v-model="editedItem.qty" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.qty}}</span>
        </template>
        <template v-slot:item.price="{ item }">
          <v-text-field v-model="editedItem.price" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{tocurr(item.price)}}</span>
        </template>
        <template v-slot:item.unit="{ item }">
          <v-select v-model="editedItem.unit" :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', '']" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-select>
          <span v-else>{{item.unit}}</span>
        </template>
        <template v-slot:item.kind="{ item }">
          <v-select v-model="editedItem.kind" :items="['part', 'service']" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-select>
          <span v-else>{{item.kind}}</span>
        </template>
        <template v-slot:item.gross="{ item }">
          <span v-if="isNaN(item.price)"></span>
          <span v-else>{{ tocurr(item.qty*item.price)}}</span>
        </template>
        <template v-slot:item.vat="{ item }">
          <span v-if="isNaN(item.price)"></span>
            <span v-else>{{ tocurr(item.qty*item.price*0.24)}}</span>
        </template>
        <template v-slot:item.value="{ item }">
          <span v-if="isNaN(item.price)"></span>
            <span v-else>{{ tocurr(item.qty*item.price*1.24)}}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div v-if="item.id === editedItem.id">
            <v-icon color="error" class="mr-3" @click="close">
              mdi-window-close
            </v-icon>
            <v-icon color="primary"  @click="save">
              mdi-content-save
            </v-icon>
          </div>
          <div v-else>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon>
            <v-icon @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>

import filter from "lodash/filter";
import sortBy from "lodash/sortBy";

export default {
  props: {
    //lineItems: []
  },
  data () {
    return {
    valid: true,
    search: null,
    searchCustomer: null,
    isLoading: false,
    notes: '',
    vehicles: [],
    customers: [],
    customer: {customer_id: ''},
    recipient: '',
    vehicle: '',
    total: 0.0,
    vat: 0.0,
    net: 0.0,
    headers: [
      {
        text: 'A/A',
        value: 'index',
        sortable: false,
        width: '10%'
      },
      {
        text: 'Κωδικός',
        value: 'sku',
        sortable: false,
        width: '15%'
      },
      {
        text: 'Περιγραφή',
        value: 'description',
        sortable: false,
        width: '35%'
      },
      {
        text: 'Ποσότητα',
        value: 'qty',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'price',
        sortable: false
      },
      {
        text: 'Καθ. Αξία',
        value: 'gross',
        sortable: false
      },
      {
        text: 'ΦΠΑ',
        value: 'vat',
        sortable: false
      },
      {
        text: 'Αξία',
        value: 'value',
        sortable: false
      },
      {
        text: 'ΤΥΠΟΣ',
        value: 'kind',
        sortable: false,
        width: '5%',
      },
      { text: 'Actions', value: 'actions', sortable: false , width: "150px"},
    ],
    lineItems: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      sku: '000-0000',
      description: '',
      qty: 0,
      unit: 'ΤΕΜ',
      price: 0,
      kind: 'part',
    },
    defaultItem: {
      id: 0,
      sku: '000-0000',
      description: '',
      qty: 1,
      unit: 'ΤΕΜ',
      price: 0,
      kind: 'part'
    }
    }
  },
  async created () {
      this.initialize();
       const response = await this.$api.get("/quotes/customers");
      this.customers = sortBy(response.data, 'Name');
      // console.log(this.customer);
      // console.log(this.$route.query.cid);
      if (this.$route.query.cid) {
        //this.customer = filter(this.customers, {'customer_id': this.$route.query.cid});
        this.customer = this.customers.find(item =>item.Cid === this.$route.query.cid);
        this.updateVehicleList();
        //this.customer = this.$route.query.cid;
      }
  },

  watch: {
    searchCustomer () {
     // this.initCustomers();
      },
  },
  methods: {
    initCustomers() {
        // Items have already been loaded
        if (this.customers.length > 0) return

        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
      // this.$api.get('/customers/search', {params: {q: val}})
      this.$api.get('/quotes/customers')
          .then(res => res.data)
          .then(res => {
            const customers = res
            this.customers = sortBy(customers, 'Name')
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
    },
    initialize () {
      this.lineItems = [
        {
          id: 1,
          sku: '000-00000',
          description: 'Περιγραφή',
          price: 0,
          qty: 1,
          unit: 'ΤΕΜ',
          kind: 'part'
        },
        {
          id: 2,
          sku: '030',
          description: 'ΕΞΑΓΩΓΗ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΑΝΤΑΛΛΑΚΤΙΚΩΝ',
          price: 0,
          qty: 1,
          unit: '',
          kind: 'service'
        },
      ]
    },

    async updateVehicleList() {
        const resp = await this.$api.get("/repairs/vehicles/customer/"+this.customer.Cid);
      if (resp.status == 200) {

      this.vehicles = resp.data;

      } else {
        this.vehicles = [];
      }

    },
    rowClass (item) {
      return this.lineItems.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.id = this.lineItems.length + 1;
      this.lineItems.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.lineItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },

    deleteItem (item) {
      const index = this.lineItems.indexOf(item);
     // confirm('Are you sure you want to delete this item?') &&
      this.lineItems.splice(index, 1);
    },

    close () {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.id = this.lineItems.length + 1;
       console.log(addObj);
       this.lineItems.unshift(addObj);
       this.editItem(addObj);
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.lineItems[this.editedIndex], this.editedItem)
      }
      this.close()
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.price*b.qty || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    async saveQuote() {

      if (this.$refs.form.validate()) {
      let quote = {
        //customer: this.customer.info.name,
        cid: this.customer.Cid,
        recipient: this.recipient,
        vehicle: this.vehicle,
        notes: this.notes,
        part_items: filter(this.lineItems, {'kind': 'part'}),
        work_items: filter(this.lineItems, {'kind': 'service'}),
      }
     const resp = await this.$api.post("/quotes", quote);

     this.$router.push('/quote/edit/'+resp.data);
    }
    }
  },
}
</script>
